import type en from "../en/studio";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  pageTitle: "استوديو الذكاء الاصطناعي",
  versionHistory: "سجل الإصدارات",
  showHistory: "إظهار سجل الإصدارات",
  hideHistory: "إخفاء سجل الإصدارات",
  chatTab: "المحادثة",
  previewTab: "المعاينة",
  viewLabel: "عرض الاستوديو",
  previewLabel: "معاينة المتجر",
  pageSelect: "الصفحة",
  pageHome: "الرئيسية",
  pageProducts: "جميع المنتجات",
  pageCollections: "المجموعات",
  languageSelect: "لغة المعاينة",
  device: "الجهاز",
  desktop: "حاسوب",
  tablet: "جهاز لوحي",
  mobile: "هاتف",
  editToggle: "تعديل النصوص والألوان والصور مباشرة",
  editDefaultOnly: "التعديل المباشر متاح باللغة الافتراضية للمتجر فقط. غيّر لغة المعاينة للتعديل.",
  editNotAllowed: "ليست لديك صلاحية تعديل تصميم هذا المتجر.",
  refresh: "تحديث المعاينة",
  openNewTab: "فتح في علامة تبويب جديدة",
  editHint: "انقر على نص لكتابته · انقر على صورة لتبديلها · اختر الألوان — يُحفظ في المسودة",
  cancelEdit: "إلغاء",
  colorPrimary: "العلامة",
  colorBackground: "الخلفية",
  colorText: "النص",
  colorsLabel: "ألوان القالب",
  saving: "جارٍ الحفظ…",
  saved: "تم الحفظ في المسودة",
  saveFailed: "تعذّر الحفظ: {error}",
  dismiss: "إغلاق",
  bridgeSave: "حفظ",
  bridgeCancel: "إلغاء",
  errTarget: "لا يمكن تعديل هذا العنصر هنا.",
  errPage: "هذه الصفحة لم تعد موجودة. حدّث المعاينة.",
  errSection: "هذا القسم لم يعد موجودًا. حدّث المعاينة.",
  errField: "لا يمكن تعديل هذا الحقل مباشرة.",
  errImage: "اختر صورة من مكتبة الوسائط.",
  errColor: "اختر لونًا صالحًا.",
  heroTitle: "صِفه. ونحن نبنيه.",
  heroSubtitle: "أخبر الذكاء الاصطناعي بما تبيعه والأسلوب الذي تحبه — وسيبني القالب والصفحات والتنقل لك.",
  heroPlaceholder: "مثال: أريد إنشاء متجر للجاكيتات باسم Jaketo — جاكيتات رجالية فقط، العملة درهم مغربي، في المغرب، الموقع بالفرنسية…",
  heroInputLabel: "صِف متجرك",
  heroPlan: "خطة",
  heroPlanHint: "اطّلع على خطة خطوة بخطوة قبل البناء",
  heroGenerate: "إنشاء",
  heroOutOfCredits: "نفد رصيدك — اشحن محفظتك لمواصلة البناء",
  heroFundNow: "اشحن محفظتك الآن ←",
  heroTalk: "لا تعرف من أين تبدأ؟ تحدّث إلى ذكاء Storelancer الاصطناعي",
};

export default ar;
